import { convertDataLayerPayload } from '../transformers';
import { DATA_LAYER_OPTIONS } from '../../constants';
import { pushToDataLayer } from '..';

const pushPurchase = (payload, passedOption, transactionId) => {
  if (!payload || !passedOption || !transactionId) {
    return;
  }

  let option = passedOption;

  if (
    passedOption === DATA_LAYER_OPTIONS.BROCHURE_REQUEST ||
    passedOption === DATA_LAYER_OPTIONS.CALL_BACK_REQUEST ||
    passedOption === DATA_LAYER_OPTIONS.DECKPLANS_REQUEST ||
    passedOption === DATA_LAYER_OPTIONS.FULL_SPECS_REQUEST
  ) {
    option = DATA_LAYER_OPTIONS.MESSAGE;
  }

  pushToDataLayer({
    event: 'Ecommerce Purchase',
    ...convertDataLayerPayload(payload),
    ecommerce_option: option,
    ecommerce_transaction_id: transactionId
  });
};

export default pushPurchase;
